<template>
<div class="row h-100 mh-100">
  <template v-if="products.length == 0">
    <p class="text-center">Cart is empty.</p>
  </template>
  <template v-else>
  <div class="h-100 mh-100 col-12 d-flex flex-column justify-content-between cart">
    <div class="row h-100 mh-100 d-block overflow-auto">
      <div class="col-12 h-100 mh-100">
      <template v-for="product in products" v-bind:key="product.id">
        <CartItem :id="product.id" :title="product.title" :primaryAuthor="product.primaryAuthor" :isbn="product.isbn" :format="product.format" :quantity="product.quantity" :price="product.price" :coverURL="product.coverURL"/>
      </template>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="grey">
          <p class="pt-3" v-html="cartMessage"></p>
        </div>
      <CartFooter heading="Subtotal" :lineValue="calculateSubtotal(products)" :inputField="false"/>
      <CartFooter heading="Discount Code" :lineValue="0 !== discountAmount ? discountAmount : discountPercentage * calculateSubtotal(products)" :inputField="true" :inputValue="discountCode"/>
      <div class="d-flex justify-content-between total py-2">
        <p class="my-auto">{{ calculateTotalQuantity(products) }} Items</p>
        <p class="my-auto">{{ useFormatPrice(calculateTotal(products)) }}</p>
      </div>
      <button type="button" data-type="link-event" data-category="Ecommerce" data-action="Checkout" :data-label="this.webUrl" class="btn btn-primary checkout mb-2" @click="checkout">Checkout</button>
    </div>
    </div>
  </div>
  </template>
  </div>
</template>

<script>
// import CheckoutDataService from "@/services/useCheckout";
import CartItem from '../components/CartItem.vue'
import CartFooter from '../components/CartFooter.vue'
import { useFormatPrice } from '../helpers/formatPrice.js'
import {mapGetters} from 'vuex';
import Logger from '../helpers/logger';

export default {
  name: 'ShoppingCart',
  props: {
  },
  components: {
    CartItem, CartFooter
  },
  async created() {
    // if(this.cartId != ''){
    //   this.fetchData();
    // }

    if(this.cartId !== ''){
      await this.loadCart();
    }
    await this.fetchData();

    window.EventBus.addEventListener('add-to-cart', event => {
      let variantId = event.detail.variantId;
      let quantity = event.detail.quantity;
      Logger.log("ADD TO CART EVENT RECEIVED");
      Logger.log(variantId);
      Logger.log(quantity);
      
      if(this.cartId == ''){
        (async () => {
          await this.initCart();
          this.addToCart(variantId, quantity);
        })();
      } else{
          this.addToCart(variantId, quantity);
        }
    });
  },
  // watch: {
  //   'products': 'fetchData'
  // },
  computed: {
    ...mapGetters({
      products: 'products'
    }),
    // products() {
    //   return this.$store.getters.products;
    // },
    webUrl() {
      return this.$store.getters.webUrl;
    },
    cartId() {
      return this.$store.getters.cartId;
    },
    discountCode() {
      return this.$store.getters.discountCode;
    },
    discountAmount() {
      return this.$store.getters.discountAmount;
    },
    discountPercentage() {
      return this.$store.getters.discountPercentage;
    },
    cartMessage() {
      return typeof window.source !== 'undefined' ? window.source.cartMessage : 'Shipping and taxes calculated at checkout. You may experience shipping delays. Please see <a href="https://www.hachettebookgroup.com/about/faqs/">FAQ</a>.';
    }
  },
  methods: {
    useFormatPrice: useFormatPrice,
    calculateSubtotal(lineItems){
      return lineItems.map(item => (item.quantity * item.price)).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    },
    calculateTotal(lineItems){
      return this.calculateSubtotal(lineItems) + (0 !== this.discountAmount ? this.discountAmount : (this.discountPercentage * this.calculateSubtotal(lineItems)));
    },
    calculateTotalQuantity(lineItems){
      return lineItems.map(item => item.quantity).reduce((a,b) => a+b, 0);
    },
    async fetchData(){
      await this.$store.dispatch('getProducts', {
        id: this.cartId
      });
    },
    async initCart(){
      await this.$store.dispatch('initCart', {})
    },
    async loadCart(){
      await this.$store.dispatch('loadCart', {
        id: this.cartId
      })
    },
    async addToCart(variantId, quantity){
      await this.$store.dispatch('addToCart', {
        variantId: variantId,
        quantity: quantity
      })
    },
    async checkout(){
      await this.$store.dispatch('setReferrer', {
        referrer: window.location.href
      })
      window.location.href = this.webUrl;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cart{
  /* max-height: 92%; */
}
.checkout{
  width: 100%;
}
.shopping-cart-interior .btn-primary{
  background-color: #e13424 !important;
  border-color: #B42518 !important;
  font-weight: 600;
  font-size: 1.25rem;
}
.shopping-cart-interior .btn-primary:hover{
  background-color: #C1281A !important;
  border-color: #B42518 !important;
}

.total{
  font-weight: bold;
  font-size: 1.25rem;
  border-top: 1px solid rgba(0,0,0,.125);
}
.grey{
  color: #595959;
}
[data-theme="dark"] .grey{
  color: #B0B0B0;
}
</style>
